import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import { connect, useDispatch, useSelector } from "react-redux"
import { Link, useHistory } from "react-router-dom"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import { withTranslation } from "react-i18next"
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  showSidebarSm,
  deleteUserAccount,
} from "../../store/actions"

import { logo, logo_sm } from "assets/images/logo"
import { HiOutlineLogout } from "react-icons/hi"
import { RiShutDownLine } from "react-icons/ri"
import useWindow from "Hooks/UseWindow"

const Header = props => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { isMobile } = useWindow()

  const [sidebarSm, setSidebarSm] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collpsed")
      body.classList.toggle("sidebar-enable")
    }
    setSidebarSm(!sidebarSm)
  }

  const toggleDeleteModal = () => setShowDeleteModal(prev => !prev)

  const handleLogout = () => {
    localStorage.clear()
    sessionStorage.clear()
    history.push("/login")
  }

  const handleDeleteUser = () => {
    dispatch(deleteUserAccount({ history }))
    window.location.reload()
  }

  useEffect(() => {
    dispatch(showSidebarSm(sidebarSm))
  }, [dispatch, sidebarSm])

  const { sideBarSm } = useSelector(state => ({
    sideBarSm: state.Layout.sideBarSm,
  }))

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  return (
    <React.Fragment>
      {isMobile ? (
        <>
          <div
            className="d-flex align-items-center justify-content-between p-3 px-4"
            style={{
              backgroundColor: "#034e60",
              boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
            }}
          >
            <div>
              <img
                src={logo}
                alt="header-logo"
                style={{
                  objectFit: "contain",
                  height: 30,
                  width: 80,
                }}
              />
            </div>
            <div className="d-flex align-items-center gap-3">
              <HiOutlineLogout
                style={{ cursor: "pointer", color: "#000" }}
                size={"1.3rem"}
                onClick={handleLogout}
              />
              <RiShutDownLine
                style={{ cursor: "pointer", color: "red" }}
                size={"1.3rem"}
                onClick={toggleDeleteModal}
              />
            </div>
          </div>

          <Modal
            isOpen={showDeleteModal}
            toggle={toggleDeleteModal}
            centered
            size="sm"
          >
            <ModalHeader toggle={toggleDeleteModal}>
              Confirm Deletion
            </ModalHeader>
            <ModalBody>
              Are you sure you want to delete your account?.
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={toggleDeleteModal}>
                Cancel
              </Button>
              <Button color="danger" onClick={handleDeleteUser}>
                Yes, Delete
              </Button>
            </ModalFooter>
          </Modal>
        </>
      ) : (
        <header id="page-topbar">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box d-md-block">
                <Link to="/" className="logo logo-dark">
                  <span
                    className="logo-sm"
                    style={{
                      width: sideBarSm ? "35px" : "",
                    }}
                  >
                    {sideBarSm ? (
                      <img
                        src={logo_sm}
                        alt="header-logo"
                        style={{
                          objectFit: "contain",
                          height: 20,
                          width: 70,
                        }}
                      />
                    ) : (
                      <img
                        src={logo}
                        alt="header-logo"
                        style={{
                          objectFit: "cover",
                          height: "20px",
                          width: "100%",
                        }}
                      />
                    )}
                  </span>
                </Link>
              </div>
              {isMobile && (
                <button
                  type="button"
                  onClick={() => {
                    tToggle()
                  }}
                  className="btn btn-sm px-3 font-size-16 header-item "
                  id="vertical-menu-btn"
                >
                  <i className="fa fa-fw fa-bars" />
                </button>
              )}
            </div>
            <div className="d-flex">
              <ProfileMenu />
              <div className="dropdown d-none d-lg-inline-block ms-1">
                <button
                  title="Full Screen"
                  type="button"
                  onClick={toggleFullscreen}
                  className="btn header-item noti-icon"
                  data-toggle="fullscreen"
                >
                  <i className="bx bx-fullscreen" />
                </button>
              </div>
            </div>
          </div>
        </header>
      )}
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
